import { cx } from "cva";

import { CircularProgress } from "../CircularProgress";
import { ButtonProps, variants } from "./";

export const Button = ({
  className,
  disabled,
  children,
  type = "button",
  variant,
  width,
  color,
  loading,
  ...props
}: Readonly<ButtonProps>) => (
  <button
    disabled={disabled || loading}
    type={type}
    className={cx(className, variants({ variant, width, color, loading }))}
    {...props}
  >
    {loading ? <CircularProgress /> : children}
  </button>
);
